import qs from 'query-string';
import Button from 'modules/common/Button';
import React, { useEffect, useState } from 'react';
import default_logo from 'assets/img/logo.svg';
import default_logo_alt from 'assets/img/logo-inverted.svg';

function removeCss(id) {
  const { head } = document;
  const el = document.getElementById(id);
  head.removeChild(el);
}

function appendCss(id, path) {
  const { head } = document;
  const el = document.getElementById(id);
  if (el) removeCss(id);
  const link = document.createElement('link');

  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.id = id;
  link.href = path;

  head.appendChild(link);
}

export { appendCss, removeCss };

export const THEMES = {
  Dark: '/theme/dark.css',
  default: '/theme/default.css',
};

const THEMES_LOGO = {
  Dark: default_logo_alt,
  default: default_logo,
};

export const ThemeSwitcher = () => (
  <div className="flex">
    <Button onClick={() => appendCss('theme-style', THEMES.default)} size="xs">
      Default
    </Button>
    <Button onClick={() => appendCss('theme-style', THEMES.dark)} size="xs">
      Dark
    </Button>
  </div>
);

const useTheme = (auth) => {
  const [data, setData] = useState({
    logo: default_logo,
    app_name: 'GameBox Lobby',
  });
  useEffect(() => {
    if (auth) {
      // console.log('load theme from api!', auth); // eslint-disable-line
      return;
    }
    const query = qs.parse(window.location.search);
    if (query.theme) {
      // console.log('load theme!', query.theme); // eslint-disable-line
      setData((state) => ({
        ...state,
        logo: THEMES_LOGO[query.theme] || THEMES_LOGO.default,
      }));
      appendCss('theme-style', THEMES[query.theme] || THEMES.default);
      return;
    }
    appendCss('theme-style', THEMES.default);
    console.log('default theme!'); // eslint-disable-line
  }, [auth, setData]);
  return [data];
};

export default useTheme;
